import React, { useEffect, useState } from "react";
import ModalBox from "../../Components/modals/ModalBox";
import { MakeAxiosRequest } from "../../utils/handler";
import OrderServiceForImg from "../../Assets/Images/orderservicefor.png";

function OrderingServiceSelectModal({ showModal, closeModal, createRelation, updateProfile }) {  
  
  const [response, setResponse] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [showModal]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await MakeAxiosRequest("post", "/getorderingserviceinfo");
      if (res.status == 1) {
        setResponse(res.data?.info);
        setIsLoading(false);
      } else {
        console.log(res.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleSelect = (type='skip') => {
    if(type==="myself"){
      updateProfile();
    }else if(type==="relation"){
      createRelation();
    }
    MakeAxiosRequest("post", "/updateorderingservicestatus",{type});
    closeModal();
  };

  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="md"
      hasData={!isLoading}
    >
      <div className="col-12 mt-3">
        <div className="row align-items-start">
            
                <div className="col-12 text-center">
                  <img
                    className="highlightImg mb-4"
                    src={OrderServiceForImg}
                    alt="bg-days.png"
                  />
                  <h4>{response?.title}</h4>
                  <p>{response?.description}</p>
                </div>
                <div className="col-12 mb-3">
                  <div className="mx-xxl-2 text-center">
                    {response?.buttons
                      ?.filter((item) => item.isshow === 1)
                      .map((item, index) =>
                        item.type !== "other" ? (
                          <button
                            key={index}
                            className="btn btn-primary rounded-pill w-100 mt-3"
                            onClick={() => handleSelect(item.type)}
                          >
                            {item.title}
                          </button>
                        ) : (
                          <a
                            key={index}
                            href="javascript:void(0)"
                            className="mt-3 d-block"
                            onClick={() => handleSelect('skip')}
                          >
                            {item.title}
                          </a>
                        )
                      )}
                    
                  </div>
                </div>
           
          </div>
      </div>
    </ModalBox>
  );
}

export default OrderingServiceSelectModal;
